import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveButton',
  props: {
  removeButtonText: {
    type: String,
    required: true,
  },
},
  emits: {
  remove: () => true,
},
  setup(__props, { emit }) {





const handleClick = () => {
  emit('remove');
};

return { __sfc: true,emit, handleClick }
}

})